import { useState, useEffect } from "react";
import StorageUtil from "../../utils/storageUtil";
import ViewUtils from "../../utils/viewUtility";
import { useLocation, useHistory } from "react-router-dom";
import routes from "../../utils/routes";
import { useDispatch } from "react-redux";
import { LOG_OUT } from "../../modules/auth/actionTypes";
let requestLoaderConfig = false;
export default (httpClient) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  const [isLoading, setLoader] = useState(false);
  const [isServerError, setServerError] = useState(false);

  useEffect(() => {
    setServerError(false);
  }, [location]);

  const reqInterceptor = httpClient.interceptors.request.use((req) => {
    if (!req.config || !req.config.noLoader) {
      setLoader(true);
    }
    if (req?.config?.headers) {
      req.headers = { ...req.headers, ...req.config.headers };
    }
    if (req.config) requestLoaderConfig = req.config.persistLoader;
    if (req.config && req.config[ViewUtils.NO_HEADER]) return req;
    const token = StorageUtil.getData(ViewUtils.SECURITY_TOKEN);
    const userKey = StorageUtil.getObject(ViewUtils.USER_DATA);
    if (token) {
      req.headers[ViewUtils.SECURITY_TOKEN] = token;
      req.headers[ViewUtils.USER_KEY] = userKey.id;
    }
    return req;
  });

  const resInterceptor = httpClient.interceptors.response.use(
    (res) => {
      if (res) {
        setServerError(false);
      }
      if (!requestLoaderConfig) {
        setLoader(false);
      }
      // If status code 200 and res have status and its value is 'ERROR'
      if (res?.data?.status && res.data.status === "ERROR") {
        setLoader(false);
      }
      return res;
    },
    (error) => {
      setLoader(false);
      if (error.response && error.response.status === 401) {
        StorageUtil.removeAll();
        dispatch({ type: LOG_OUT });
        history.push(routes.LOGIN);
      } else if (error.response && (error.response.status === 400 || error.response.status > 401)) {
        setServerError(true);
      } else {
      }
    }
  );

  useEffect(() => {
    return () => {
      httpClient.interceptors.request.eject(reqInterceptor);
      httpClient.interceptors.response.eject(resInterceptor);
    };
  }, [reqInterceptor, resInterceptor, httpClient.interceptors.request, httpClient.interceptors.response]);

  // const errorConfirmedHandler = () => {
  //   //setError(null);
  // };
  return [isLoading, isServerError];
};
